import { getTRSNodes } from './getTRSNodes';

export const fetchTRSNodes = async (clusterID = null) => {
    try {
        const response = await getTRSNodes(clusterID);
        return response.data;
    } catch (error) {
        console.error('Error fetching TRS nodes:', error);
        throw error;
    }
};
